var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-data-table',{attrs:{"items":_vm.items_proveedores,"headers":_vm.headers_proveedores},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.generarExcel()}}},[_vm._v("Generar")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }